export function exportToCsv(data, filename) {
  if (!data || data.length === 0) return;

  // Flatten nested objects for CSV
  const flattenRow = (row) => {
    const flat = {};
    for (const [key, val] of Object.entries(row)) {
      if (val && typeof val === 'object' && !Array.isArray(val)) {
        for (const [subKey, subVal] of Object.entries(val)) {
          flat[`${key}_${subKey}`] = subVal;
        }
      } else if (Array.isArray(val)) {
        flat[key] = val.join('; ');
      } else {
        flat[key] = val;
      }
    }
    return flat;
  };

  const flatData = data.map(flattenRow);
  const headers = [...new Set(flatData.flatMap(Object.keys))];

  const escape = (val) => {
    if (val === null || val === undefined) return '';
    const str = String(val);
    if (str.includes(',') || str.includes('"') || str.includes('\n')) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  };

  const csv = [
    headers.join(','),
    ...flatData.map(row => headers.map(h => escape(row[h])).join(',')),
  ].join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}-${new Date().toISOString().split('T')[0]}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
